import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import {
  DefaultFsBbox,
  ILprExportParamsInterface,
} from '../../api/interfaces/lpr-export-params.interface';
import { QueriesSearchParams } from '../../utils/lpr.utils';

export class LprExportParams extends SnModel implements ILprExportParamsInterface {
  @Expose()
  searchReason?: string;

  @Expose()
  fromDate?: Date;

  @Expose()
  toDate?: Date;

  @Expose()
  plate?: string;

  @Expose()
  plateState?: string;

  @Expose()
  vehicleColor?: string[];

  @Expose()
  vehicleMake?: string;

  @Expose()
  vehicleBody?: string;

  @Expose()
  vehicleName?: string;

  @Expose()
  recordType?: string;

  @Expose()
  assignedUserIds?: string[];

  @Expose()
  deviceNames?: string[];

  @Expose()
  caseNumber?: string;

  @Expose()
  inBbox?: QueriesSearchParams | DefaultFsBbox;
}
